import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { remoteLogin, setRedirectUrl } from '../../actions/auth.actions';

import { AppState } from 'src/app/reducers';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectIsAuthLoading } from '../../reducers';

@Component({
    selector: 'app-remote-login',
    templateUrl: './remote-login.component.html',
    styleUrl: './remote-login.component.scss',
    standalone: false
})
export class RemoteLoginComponent {
  authLoading: Observable<boolean>;

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
  ) {
    this.authLoading = this.store.select(selectIsAuthLoading);
  }

  ngOnInit() {
    const token = this.route.snapshot.params['authToken'];
    this.store.dispatch(setRedirectUrl({ url: '/analytics/home' }));
    this.store.dispatch(remoteLogin({ token }));
  }
}
